import React from "react";
import { icons } from "../../constants";
import "./styles/styles.css";

// Kept in sync with PASSWORD_REGEX in ForgottenPasswordPage.jsx/ChangePassword.jsx
// and validatePasswordComplexity in gs.be/helpers/globals.js.
const RULES = [
  { key: "length", test: (v) => v.length >= 12, labelKey: "UI_PW_RULE_LENGTH" },
  { key: "lowercase", test: (v) => /[a-z]/.test(v), labelKey: "UI_PW_RULE_LOWERCASE" },
  { key: "uppercase", test: (v) => /[A-Z]/.test(v), labelKey: "UI_PW_RULE_UPPERCASE" },
  { key: "number", test: (v) => /\d/.test(v), labelKey: "UI_PW_RULE_NUMBER" },
  { key: "special", test: (v) => /[\W_]/.test(v), labelKey: "UI_PW_RULE_SPECIAL" },
];

const PasswordRequirements = ({ password = "", t, className }) => {
  return (
    <div className={`flex-direction-column gap-8 password-requirements ${className || ""}`}>
      <div className="flex-direction-row items-center gap-8">
        <img src={icons.warning} width={16} height={16} alt="" />
        <p className="font-12 inria-sans-700 password-requirements-title">
          {t("UI_PW_REQUIREMENTS_TITLE")}
        </p>
      </div>
      <ul className="password-requirements-list">
        {RULES.map((rule) => {
          const met = rule.test(password);
          return (
            <li
              key={rule.key}
              className={`font-12 inria-sans-400 password-requirements-item ${met ? "met" : ""}`}
            >
              <span className="password-requirements-check">
                {met ? "✓" : ""}
              </span>
              {t(rule.labelKey)}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
